import axios from "axios";
import { useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Connexion from "../../Views/Register/Connexion";
import { MagasinContext } from "../../Context/MagasinContext";
import ConnexionMobil from "../../Views/Utilisateure/UtilisateurMobil/ConnexionMobile";
import RegisterMobile from "../../Views/Register/RegisterMobile";

export default function LoginServiceMobile() {
  const [CompteEmail, setCompteEmail] = useState("");
  const [message, setMessage] = useState("");
  const [PopUp, setPopUp] = useState<boolean>(false);
  const [commercialsList, setCommercialsList] = useState<any[]>([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const navigate = useNavigate();
  const magasinContext = useContext(MagasinContext);

  useEffect(() => {
    const visiteurId = localStorage.getItem("VisiteurId");
    const magasinId = localStorage.getItem("MagasinId");
    const commercialId = localStorage.getItem("CommercialId");
    const clientId = localStorage.getItem("ClientId");
    const roleName = localStorage.getItem("roleName");

    if (visiteurId) {
      navigate('/visiteurs');
    } else if (magasinId) {
      navigate(`/magasins/${magasinId}`);
    } else if (commercialId) {
      navigate(`/commercials/${commercialId}`);
    } else if (clientId) {
      navigate(`/clients/${clientId}`);
    } else if (roleName) {
      navigate('/home');
    }
  }, [navigate]);

  const [Password, setPassword] = useState("");
  // const [messageEror, setMessageErors] = useState("");
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const url = `${process.env.REACT_APP_PHP_APP_URL}/connexion`;
    try {
      const response = await axios.post(
        url,
        { CompteEmail, Password },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.message === "magasins") {
        const IdMagasin = response.data.account.id;
        const NameMagasin = response.data.account.NomMagasin;
        const adresse = response.data.account.adresse_de_siege;
                navigate(`/magasins/${IdMagasin}`);

        const savedId = localStorage.getItem("MagasinId");
        localStorage.setItem("MagasinId", savedId || IdMagasin);
        const savedNameMagasin = localStorage.getItem("MagasinName");
        localStorage.setItem("MagasinName", savedNameMagasin || NameMagasin);
        const savedAdresse = localStorage.getItem('adresse');
        localStorage.setItem('adresse', savedAdresse || adresse);
        magasinContext.setadresse({
          adresse:savedAdresse || adresse,
        });
        magasinContext.setId({
          id: savedId || IdMagasin,
        });
        magasinContext.setNameMagasin({
          nameMagasin: savedNameMagasin || NameMagasin,
        });
        // Connexion as Commercial

      } else if (response.data.message === "commercials") {
        const accountData = response.data.account;
        if (Array.isArray(accountData)) {
          setCommercialsList(accountData);
          setPopUp(true);
        } else {
          const IdCommercial = accountData.id;
          const NameCommercial = accountData.Nom;

          navigate(`/commercials/` + IdCommercial);
          const savedId = localStorage.getItem("CommercialId");
          localStorage.setItem("CommercialId", savedId || IdCommercial);

          const savedNameCommercial = localStorage.getItem("CommercialName");
          localStorage.setItem(
            "CommercialName",
            savedNameCommercial || NameCommercial
          );
          magasinContext.setId({
            id: savedId || IdCommercial,
          });
          magasinContext.setNameMagasin({
            nameComercial: savedNameCommercial || NameCommercial,
          });
        }

        // Connexion as Client
      } else if (response.data.message === "clients") {
        // console.log(response.data);
        const IdClient = response.data.account.IdClient || response.data.account.id;
        const AccountId = response.data.account_id || IdClient; // utilisateur__accounts.id for commandes
        const NameClient = response.data.account.NomClient;
        const IdMagasinLiee = response.data.account.idMagasin || response.data.account.IdMagasin;
        navigate(`/clients/` + AccountId);
        const savedId = localStorage.getItem("ClientId");
        localStorage.setItem("ClientId", savedId || AccountId);
        localStorage.setItem("ClientDynamicId", IdClient);

        const savedNameClient = localStorage.getItem("ClientName");
        localStorage.setItem("ClientName", savedNameClient || NameClient);

        if (IdMagasinLiee) {
          localStorage.setItem('idMagasinLiee', IdMagasinLiee.toString());
        }
        magasinContext.setId({
          id: savedId || AccountId,
        });
        magasinContext.setNameMagasin({
          nameClient: savedNameClient || NameClient,
        });
      } else if (response.data.message === "admin") {
        navigate(`/home`);
        const role = response.data.message;
        const savedNameRole = localStorage.getItem("role");
        localStorage.setItem("roleName", savedNameRole || role);
        magasinContext.setNameMagasin({
          role: savedNameRole || role,
        });
      } else if (response.data.message === "vous navez accune compte avec ce email" || response.data.message === "le mot de passe incorrect" || response.data.message === "False information") {
        setMessage(response.data.message === "False information" ? "incorrect compte" : response.data.message);
        setPopUp(true);
        const timeoutId = setTimeout(() => {
          setPopUp(false);
          setMessage("");
        }, 3000);
      } else if(response.data.message === "Visiteurs"){
        console.log('hna');
      localStorage.setItem("VisiteurId", response.data.account.id);
      localStorage.setItem("VisiteurName", response.data.account.Nom_Complet);
      localStorage.setItem("VisiteurAdresse", response.data.account.Adresse);
      localStorage.setItem("VisiteurTele", response.data.account.Tele);
      navigate('/visiteurs')
      }else if (response.data.message === "magasin bloqué") {
        setMessage("ce magasin et bloqué");
        const timeoutId = setTimeout(() => {
          setMessage("");
        }, 3000);
      }
    } catch (error) {
      console.error("error:", error);
    }
  };
  return (
    <>
      <RegisterMobile
        handleSubmit={handleSubmit}
        Password={Password}
        PopUp={PopUp}
        commercialsList={commercialsList}
        setCompteEmail={setCompteEmail}
        CompteEmail={CompteEmail}
        setPassword={setPassword}
        message={message}
      />
    </>
  );
}
